
import { Component, Watch } from 'vue-property-decorator'
import ShrinkableMenu from '@/components/shrinkable-menu/index.vue'
import TagsPageOpened from '@/components/tags-page-opened/tags-page-opened.vue'
import FullScreen from '@/components/fullscreen.vue'
import MainHeader from '@/components/main-header/index.vue'
// 2026-08-22 - Added by AI (CR-25-09) - Select Working Zone popup
import SelectWorkingZone from '@/components/select-working-zone/index.vue'
import util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import cssStyle from '@/assets/styles/_variables.scss'

@Component({
  components: {
    ShrinkableMenu,
    TagsPageOpened,
    FullScreen,
    MainHeader,
    SelectWorkingZone
  }
})
export default class Main extends AbpBase {
  // 左侧菜单折叠状态
  collapse: boolean = false

  // 2026-08-22 - Added by AI (CR-25-09) - Select Working Zone popup state
  showZoneDialog: boolean = false
  zoneDialogMandatory: boolean = false

  /**
   * 該使用者的 role 是否被設定為 MultipleStore。
   * 來源是登入時 TokenAuth 回傳的旗標，存在 sessionStorage ——
   * 因為 login/index.vue 會 location.reload()，而本組件的 mounted
   * 可能早於 main.ts 的 session/init 完成，不能依賴需要 API 的資料。
   */
  get allowMultipleWorkingZone(): boolean {
    return sessionStorage.getItem('allowMultipleWorkingZone') === '1'
  }

  get username() {
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : ''
  }

  // isFullScreen: boolean = false;
  messageCount: string = '0'

  get openedSubMenuArr() {
    return this.$store.state.app.openedSubMenuArr
  }

  get menuList() {
    return this.$store.state.app.menuList
  }

  get pageTagsList() {
    return this.$store.state.app.pageOpenedList as Array<any>
  }

  get lang() {
    return this.$store.state.app.lang
  }

  get avatorPath() {
    return localStorage.avatorImgPath
  }

  get cachePage() {
    return this.$store.state.app.cachePage
  }

  get mesCount() {
    return this.$store.state.app.messageCount
  }

  get collapseGap() {
    return this.collapse
      ? cssStyle.sidebarCollapseWidth
      : cssStyle.sidebarExpandWidth
  }

  init() {
    let pathArr = util.setCurrentPath(this, this.$route.name as string)
    // this.$store.commit('app/updateMenuList')
    if (pathArr.length >= 2) {
      this.$store.commit('app/addOpenSubMenu', pathArr[1].name)
    }
    let messageCount = 3
    this.messageCount = messageCount.toString()
    this.checkTag(this.$route.name)
  }

  toggleSidebar() {
    this.collapse = !this.collapse
  }

  handleClickUserDropdown(command: string) {
    if (command === 'ownSpace') {
      // util.openNewPage(this, 'ownspace_index', null, null)
      // this.$router.push({
      //   name: 'ownspace_index'
      // })
    } else if (command === 'changeStore') {
      // 2026-08-22 - Added by AI (CR-25-09) - Change Store (non-mandatory, closable)
      this.zoneDialogMandatory = false
      this.showZoneDialog = true
    } else if (command === 'loginout') {
      this.$store.commit('app/setActiveMenuName', '')
      this.$store.commit('app/logout', this)
      util.abp.auth.clearToken()
      location.reload()
    }
  }

  checkTag(name?: string) {
    let openpageHasTag = this.pageTagsList.some((item: any) => {
      return item.name === name
    })
    if (!openpageHasTag) {
      util.openNewPage(
        this,
        name as string,
        this.$route.params || {},
        this.$route.query || {}
      )
    }
  }

  beforePush(name: string) {
    return name !== 'accesstest_index'
  }

  @Watch('$route')
  routeChange(to: any) {
    // console.log('Route To:' + to.name);
    this.$store.commit('app/setCurrentPageName', to.name)
    let pathArr = util.setCurrentPath(this, to.name)
    if (pathArr.length > 2) {
      this.$store.commit('app/addOpenSubMenu', pathArr[1].name)
    }
    this.checkTag(to.name)
    localStorage.currentPageName = to.name
  }

  @Watch('lang')
  langChange() {
    util.setCurrentPath(this, this.$route.name as string)
  }

  // 2026-06-16 - Added by Belline - Fixes for IST
  @Watch('menuList')
  menuListChange() {
    util.setCurrentPath(this, this.$route.name as string)
  }

  // projectTitle: String = ''

  // @Watch('collapse', { immediate: true })
  // collapseChange(newVal: boolean) {
  //   if (newVal) {
  //     setTimeout(() => {
  //       this.projectTitle = this.L('EPOD')
  //     }, 30)
  //   } else {
  //     setTimeout(() => {
  //       this.projectTitle = this.L('ALLGO EPOD')
  //     }, 120)
  //   }
  // }

  mounted() {
    this.init()
    this.checkMandatoryWorkingZone()
  }

  // 2026-08-22 - Added by AI (CR-25-09) - force working zone selection after login
  /**
   * 登入後強制選店關卡。
   *
   * 首行短路是「其他保持不變」的前端保證：role 不在 MultipleStore 設定內的
   * 使用者完全不會進入這段邏輯，行為與改動前一致。
   */
  checkMandatoryWorkingZone() {
    if (!this.allowMultipleWorkingZone) {
      return
    }
    if (sessionStorage.getItem('workingZoneConfirmed') === '1') {
      return
    }
    this.zoneDialogMandatory = true
    this.showZoneDialog = true
  }

  created() {
    this.$store.commit('app/setOpenedList')
  }
}
